import React, { Component } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { showDownloadCsvModal, showUploadCsvModal } from '../../actions';
import { DownloadCsvModal, UploadCsvModal, CsvResultsModal } from '../csv';
class CSVSegment extends Component {
    render() {
        const { inScene, showDownloadCsvModal, showUploadCsvModal } = this.props;

        return (
            <div>
                <DropdownButton
                    bsStyle='default'
                    title='CSV'
                    key='csv1'
                    id='csv-dropdown-basic1'
                >
                    <MenuItem eventKey="1" disabled={!inScene} onClick={showUploadCsvModal}>
                        <i className="fas fa-file-import"></i>&nbsp; Import
                    </MenuItem>
                    <MenuItem eventKey="2" disabled={!inScene} onClick={showDownloadCsvModal}>
                        <i className="fas fa-file-export"></i>&nbsp; Export All
                    </MenuItem>
                </DropdownButton>
                <DownloadCsvModal key='csvdownloadmodal' />
                <UploadCsvModal key='csvuploadmodal' />
                <CsvResultsModal key='csvresultsmodal' />
            </div>
        );
    }
}

CSVSegment.propTypes = {
    inScene: PropTypes.bool.isRequired,
    showDownloadCsvModal: PropTypes.func.isRequired,
    showUploadCsvModal: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    showDownloadCsvModal,
    showUploadCsvModal
};

export default connect(
    null,
    mapDispatchToProps
)(CSVSegment);



// WEBPACK FOOTER //
// ./src/components/actionBar/CSVSegment.js